import { css } from 'styled-components';
export const defaultButtonStyle = css `
  &:hover,
  &:focus {
    color: ${p => p.theme.text._2};
    background-color: ${p => p.theme.background._2};
    border-color: ${p => p.theme.border.greyNormal};
  }

  &:active {
    color: ${p => p.theme.text._1};
    background-color: ${p => p.theme.background._5};
    border-color: ${p => p.theme.border.greyNormal};
  }

  &[disabled],
  &[disabled]:hover {
    color: ${p => p.theme.text._4};
    background-color: white;
    border-color: ${p => p.theme.border.greyNormal};
  }
`;
export const primaryButtonStyle = css `
  color: white;
  background-color: ${p => p.theme.brand._1};
  border-color: ${p => p.theme.brand._1};

  &:hover,
  &:focus {
    background-color: ${p => p.theme.brand._2};
    border-color: ${p => p.theme.brand._2};
  }

  &:active {
    background-color: ${p => p.theme.brand.dark1};
    border-color: ${p => p.theme.brand.dark1};
  }

  &[disabled],
  &[disabled]:hover {
    color: white;
    background-color: ${p => p.theme.brand._4};
    border-color: ${p => p.theme.brand._4};
  }
`;
export const dangerButtonStyle = css `
  &:hover,
  &:focus {
    color: #e4524b;
    background-color: #fdefef;
  }

  &:active {
    color: #c41a1d;
    background-color: #fdefef;
    border-color: #c41a1d;
  }

  &[disabled],
  &[disabled]:hover {
    color: #f8d4d2;
    background-color: white;
    border-color: #f8d4d2;
  }
`;
export const linkButtonStyle = css `
  padding-right: 0;
  padding-left: 0;
  font-weight: ${p => p.$fontWeight || 'normal'};
  color: ${p => p.theme.brand.text0};

  &:hover,
  &:focus {
    color: ${p => p.theme.brand._2};
  }

  &[disabled],
  &[disabled]:hover {
    color: ${p => p.theme.brand._4};
  }
`;
export const specialButtonStyle = css `
  color: ${p => p.theme.brand.text0};
  background: #ffffff;
  border-color: ${p => p.theme.brand.text0};

  &:hover,
  &:focus {
    color: ${p => p.theme.brand.text0};
    background: ${p => p.theme.brand._5};
  }

  &:active {
    color: ${p => p.theme.brand.dark1};
    background: ${p => p.theme.brand._5};
    border-color: ${p => p.theme.brand.dark1};
  }

  &[disabled],
  &[disabled]:hover {
    color: ${p => p.theme.brand._4};
    background-color: white;
    border-color: ${p => p.theme.brand._4};
  }
`;
export const grayButtonStyle = css `
  color: rgba(6, 12, 25, 0.65);
  background-color: #f6f8fa;
  border-color: #f6f8fa;

  &:hover,
  &:focus {
    color: rgba(6, 12, 25, 0.85);
    background-color: #edeff2;
    border-color: #edeff2;
  }

  &:active {
    color: #ffffff;
    background: #c6c9cf;
    border-color: #c6c9cf;
  }

  &[disabled],
  &[disabled]:hover {
    color: rgba(6, 12, 25, 0.25);
    background-color: #f6f8fa;
    border-color: #f6f8fa;
  }
`;
export const reversedButtonStyle = css `
  color: rgba(6, 12, 25, 0.65);
  background-color: white;
  border-color: white;

  &:hover,
  &:focus {
    color: rgba(6, 12, 25, 0.65);
    background-color: #e7e8ed;
    border-color: #e7e8ed;
  }

  &:active {
    color: rgba(6, 12, 25, 0.85);
    background: #e4e6eb;
    border-color: #e4e6eb;
  }

  &[disabled],
  &[disabled]:hover {
    color: rgba(6, 12, 25, 0.25);
    background-color: white;
    border-color: white;
  }
`;
export const textButtonStyle = css `
  padding: 0;
  color: rgba(6, 12, 25, 0.65);
  font-weight: normal;
  background-color: transparent;
  border-color: transparent;
  outline: none;
  box-shadow: none;

  &:hover,
  &:focus,
  &:active {
    color: rgba(6, 12, 25, 0.85);
    background-color: transparent;
    border-color: transparent;
    outline: none;
  }

  &[disabled],
  &[disabled]:hover {
    background-color: transparent;
    border-color: transparent;
  }

  &[ant-click-animating-without-extra-node]:after {
    border: none;
    opacity: 0;
  }
`;
export const lightTextButtonStyle = css `
  ${textButtonStyle};

  color: rgba(6, 12, 25, 0.45);
  &:hover,
  &:focus,
  &:active {
    color: rgba(6, 12, 25, 0.65);
  }
`;
export const darkButtonStyle = css `
  color: #c6c9cf;
  background-color: #515660;
  border-color: #515660;

  &:hover,
  &:focus {
    color: #c6c9cf;
    background-color: #7c8087;
    border-color: #7c8087;
  }

  &:active {
    color: #ffffff;
    background: #7c8087;
    border-color: #7c8087;
  }

  &[disabled],
  &[disabled]:hover {
    color: #858991;
    background-color: #515660;
    border-color: #515660;
  }
`;
//# sourceMappingURL=data:application/json;base64,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